import React from "react";
import { initials, userName } from "../taskConstants";

const SIZES = {
  sm: { circle: "w-5 h-5 text-[10px]", text: "text-xs" },
  md: { circle: "w-7 h-7 text-xs", text: "text-sm" },
};

function UserChip({ user, size = "md", showName = true }) {
  if (!user) return null;
  const s = SIZES[size] || SIZES.md;
  const inactive = user.isActive === false;
  return (
    <span className="inline-flex items-center gap-2 min-w-0">
      <span
        className={`${s.circle} shrink-0 rounded-full flex items-center justify-center font-SemiBold ${
          inactive ? "bg-gray-200 text-gray-500" : "bg-primary text-main"
        }`}
        aria-hidden="true"
      >
        {initials(user)}
      </span>
      {showName && (
        <span className={`${s.text} truncate ${inactive ? "text-gray-400" : "text-gray-800"}`}>
          {userName(user)}
          {inactive && " (pasif)"}
        </span>
      )}
    </span>
  );
}

export default UserChip;
